import request from '@/utils/request'
let preBase = 'mixApi'
import { getCookie } from '@/utils/cookie'

// 女神节员工福利-发送短信
export const sendVercode = (data) => {
  return request({
    url: `${preBase}/womensDay/sendVercode`,
    method: 'post',
    data,
    hideLoading: true,
    hideErrMsgToast: true,
  })
}
// 女神节员工福利-白名单校验
export const checkWhite = (data) => {
  return request({
    url: `${preBase}/womensDay/checkWhite`,
    method: 'post',
    data,
    hideLoading: true,
    hideErrMsgToast: true,
  })
}
// 女神节员工福利-领取
export const receive = (data) => {
  return request({
    url: `${preBase}/womensDay/receive`,
    method: 'post',
    data,
    hideLoading: true,
    hideErrMsgToast: true,
    token: getCookie('womensDayToken'),

  })
}
